import { render, staticRenderFns } from "./advertisingPoliciesDetailDialog.vue?vue&type=template&id=2351ee02&scoped=true&"
import script from "./advertisingPoliciesDetailDialog.vue?vue&type=script&lang=js&"
export * from "./advertisingPoliciesDetailDialog.vue?vue&type=script&lang=js&"
import style0 from "./advertisingPoliciesDetailDialog.vue?vue&type=style&index=0&id=2351ee02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2351ee02",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCol,VDialog,VForm,VIcon,VList,VMenu,VRow,VSelect,VTextarea})
